<template>
  <div class="editor-plugin">
    <div class="input-plugin">
      <uploader-plugin></uploader-plugin>
      <div class="input-number">还可以输入 <span>{{ textNumber }}</span> 字</div>
    </div>
    <div class="input-container clearfix">
      <button class="send-btn" @click="sendMessage">发送<br/>ENTER</button>
      <div class="textarea-wrap">
        <div class="textarea-inner">
          <textarea placeholder="请用一句话完整描述您的问题, 比如:货还没到却被签收了怎么办? " v-model="userMessage" @keyup.enter="sendMessageByEnter">{{userMessage}}</textarea>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import UploaderPlugin from './UploaderPlugin'
  export default{
    data() {
      return{
        textNumber: 150,
        userMessage: '',
        tag: 'user'
      }
    },
    watch: {
      userMessage(val, oldVal) {
        if(val.length > 150){
          this.userMessage = this.userMessage.substr(0,150);
        }
      }
    },
    computed: {
      textNumber() {
        return 150 - this.userMessage.length;
      }
    },
    methods: {
      sendMessage() {
        var me = this;
        if (me.userMessage.trim()) {
          // 插入用户问题
          me.$dispatch('user-message', {message: this.userMessage, source: this.tag});
          me.userMessage = '';
        }
      },
      sendMessageByEnter() {
        var me = this;
        if (me.userMessage.trim()) {
          // 插入用户问题
          me.$dispatch('user-message', {message: this.userMessage.substring(0,this.userMessage.length-1), source: this.tag});
          me.userMessage = '';
        }
      }
    },
    components: {
      UploaderPlugin
    }
  }
</script>

<style lang="less" scoped>
  @import "../assets/base";

  .editor-plugin {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    background: #fff;
    height: 136px;
    border-top: 1px solid @borderGray;

    .input-plugin {
      display: inline-block;
      height: 30px;

      .input-number {
        position: absolute;
        top: 0;
        right: 10px;
        font-size: 12px;
        line-height: 32px;
        color: @gray;

        >span {
          color: @blue;
        }
      }
    }

    .input-container {
      .textarea-wrap {
        width: 100%;
        border-top: 1px solid @borderGray;
      }
      .textarea-inner {
        margin-right: 120px;
        padding-left: 10px;
      }
      textarea {
        width: 100%;
        height: 100px;
        padding: 10px 0;
        border: none;
        outline: none;
        resize: none;
        font-size: 14px;
        line-height: 1.5;
        color: #222;
      }
      .send-btn {
        position: relative;
        border: none;
        border-left: 1px solid @borderGray;
        float: right;
        width: 116px;
        height: 106px;
        margin-left: -116px;
        font-size: 16px;
        background-color: transparent;
        color: @main-color;
        cursor: pointer;
        outline: none;
      }

      .send-btn:hover {
        background: rgba(0,167,191,.1);
      }

      .send-btn.active {
        background: rgba(0,167,191,.2);
      }
    }
  }

  .split-line {
    height: 1px;
    max-width: 800px;
    border-top: 1px solid tint(@main-color, 40%);
    margin: 4px 10px;
  }
</style>



// WEBPACK FOOTER //
// EditorContainer.vue?b7efacda